import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import 'react-dates/initialize'
import ModalFullScreen from '../../mini/ModalFullScreen'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import CloseModal from '../../styled/CloseModal'
import { hideModal } from '../../../actions/_modal'
import { updateCourseSectionEndDate } from '../../../actions/usercourses'
import { updateCourseSectionEndDateForQuest } from '../../../actions/quest'
import {
  HeaderBlock,
  Message,
  ButtonBlock,
  ModalQuestBlock,
  Container,
  Header,
  ModalTop,
  CourseSectionName,
  GradeLevelContainer,
  OkayButton
} from './_Styled'

const CloseJourneySectionNotification = ({
  courseSection,
  grade,
  isMentor,
  data,
  location,
  userId
}) => {
  const [isClosing, setIsClosing] = useState(false)
  const dispatch = useDispatch()

  const color = courseSection.master_course.color

  const closeTheModal = () => {
    dispatch(updateCourseSectionEndDate(data.course_section.id, data.course_section.end_at))

    setIsClosing(true)

    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  return (
    <ModalFullScreen
      padding={'200px 0 0'}
      allowEscape
      closeCallback={() => closeTheModal()}
      isClosing={isClosing}
      backgroundColor='rgba(36, 54, 70, 0.4)'
      allowCloseOnExternalClick
      bodyStyles={{ width: 'fit-content' }}
    >
      <CloseModal
        size={21}
        onClick={() => closeTheModal()}
        offWhiteIcon
      />
      <Container
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <React.Fragment>
          <ModalTop>
            <CourseSectionName>
              <GradeLevelContainer>
                {grade}
              </GradeLevelContainer>
              <span style={{color: '#' + color}}>
                {courseSection.master_course.abbreviation}:&ensp;
              </span>
              <span style={{color: '#' + color}}>
                {courseSection.master_course.name}
              </span>
              <span>&ensp;|&ensp;
                {courseSection.course_section.name}
              </span>
            </CourseSectionName>
            <FlexAlignCenter
              style={{
                position: 'relative',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <HeaderBlock>
                <Header>
                  {courseSection.master_course.name} has been closed
                  <span>{isMentor ? '' : ' by your mentor'}</span>.
                </Header>
              </HeaderBlock>
            </FlexAlignCenter>
          </ModalTop>
          <ModalQuestBlock>
            <Message>
              {isMentor
              ? <p style={{ margin: '0' }}>Students will no longer be able to begin new quests within this journey.</p>
              : <p style={{ margin: '0' }}>You will no longer be able to begin new quests within this journey.</p>
              }
            </Message>
          </ModalQuestBlock>
          <ButtonBlock>
            <OkayButton
              onClick={() => closeTheModal()}
            >
              Okay
            </OkayButton>
          </ButtonBlock>
        </React.Fragment>
      </Container>
    </ModalFullScreen>
  )
}

CloseJourneySectionNotification.propTypes = {
  courseSection: PropTypes.object.isRequired,
  grade: PropTypes.string.isRequired,
  isMentor: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired
}

export default CloseJourneySectionNotification
